import { render, staticRenderFns } from "./PresencasModal.vue?vue&type=template&id=69584b24&scoped=true"
import script from "./PresencasModal.vue?vue&type=script&lang=js"
export * from "./PresencasModal.vue?vue&type=script&lang=js"
import style0 from "./PresencasModal.vue?vue&type=style&index=0&id=69584b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69584b24",
  null
  
)

export default component.exports